export default "__VITE_ASSET__DzRFDf2g__"